export const wholeNumber = (val: number | null) => {
    if (!val && val !== 0) {
        return "";
    }

    const formatter = new Intl.NumberFormat();
    return formatter.format(val);
};
